<div class="animated fadeInRight">
  <app-lfsa-card-v2
    [titulo]="mostrarEdicion ? 'Editar Viaje' : 'Editar Viaje'"
    [modulo]="GLOBAL_TITULOS.modulo"
    [tituloCard]="mostrarEdicion ? 'Detalle del Viaje' : 'Listado de Viajes'"
    [innTemplate]="mostrarEdicion ? abrirModal : enviarTemplateEdit"
    [innTemplateButton]="innTemplateButton">
  </app-lfsa-card-v2>

  <ng-template #innTemplateButton>
    <!-- <button *ngIf="mostrarEdicion" pButton type="button" label="Regresar" icon="pi pi-arrow-left" 
            (click)="mostrarEdicion = false" class="p-button-outlined p-button-secondary p-button-sm">
    </button> -->
  </ng-template>

  <ng-template #enviarTemplateEdit>
    <div class="form-group col-md-12 mp-5">
      <input class="form-control" placeholder="Buscar.." [(ngModel)]="textoBuscar" id="quickFilter" (keyup)="onQuickFilterChanged()" />

      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>

      <ag-grid-angular
        #agGrid
        (gridReady)="onGridReady($event)"
        [id]="DAT_AG_GRID.id"
        [class]="DAT_AG_GRID.class"
        [ngStyle]="DAT_AG_GRID.style"
        [rowData]="rowData"
        [rowSelection]="rowSelection"
        [columnDefs]="columnDefs"
        [pagination]="DAT_AG_GRID.pagination"
        [paginationPageSize]="DAT_AG_GRID.pagina"
        [allowContextMenuWithControlKey]="true"
        [rowHeight]="DAT_AG_GRID.rowHeight"
        [frameworkComponents]="frameworkComponents">
      </ag-grid-angular>
    </div>
  </ng-template>
</div>

<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="formulario" mat-dialog-content>
      <h6 class="fw-bold text-muted mb-2">
        <i class="fa fa-truck me-2" aria-hidden="true" style="color:#b0894a;"></i> Información del Viaje
      </h6>
      <hr class="mt-1 mb-3">

      <!-- Fila 1: Viaje, Seleccione Tipo, Origen, Bodega/Carga Origen -->
      <div class="row">
        <div class="col-md-2 form-group">
          <app-lfsa-input
            formControlName="idViaje"
            [label]="'Viaje'"
            [id]="'idViaje'"
            [control]="formulario.get('idViaje')"
            [type]="'number'"
            [isReadOnly]="true">
          </app-lfsa-input>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-combo-box [label]="'* Seleccione Tipo'" formControlName="tipo" [control]="formulario.get('tipo')"
            [comboBox]="listTipos" [opcion]="'nombre'" [idOpcion]="'idTipo'" class="form-control-sm">
          </app-lfsa-combo-box>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-combo-box
            [label]="'Origen'"
            formControlName="centroOrigen"
            [control]="formulario.get('centroOrigen')"
            [comboBox]="listCentros"
            [opcion]="'nombreCentro'"
            [idOpcion]="'idCentro'"
            class="form-control-sm">
          </app-lfsa-combo-box>
        </div>

        <div class="col-md-4 form-group">
          <app-lfsa-combo-box
            [label]="'* Bodega/Carga Origen'"
            formControlName="bodegaCarga"
            [control]="formulario.get('bodegaCarga')"
            [comboBox]="listAgencias"
            [opcion]="'dscaAlmacen'"
            [idOpcion]="'idAlmacen'"
            class="form-control-sm">
          </app-lfsa-combo-box>
        </div>
      </div>

      <!-- Fila 1.1: Destino y Andén -->
      <div class="row">
        <div class="col-md-6 form-group">
          <app-lfsa-combo-box
            [label]="'Destino'"
            formControlName="centroDestino"
            [control]="formulario.get('centroDestino')"
            [comboBox]="listCentros"
            [opcion]="'nombreCentro'"
            [idOpcion]="'idCentro'"
            class="form-control-sm">
          </app-lfsa-combo-box>
        </div>

        <div class="col-md-6 form-group">
          <app-lfsa-combo-box
            [label]="'Seleccionar andén'"
            id="andenId"
            formControlName="andenId"
            [control]="formulario.get('andenId')"
            [comboBox]="listAdenes"
            [opcion]="'nombre'"
            [idOpcion]="'idMuelle'"
            class="form-control-sm">
          </app-lfsa-combo-box>
        </div>
      </div>

      <h6 class="fw-bold text-muted mb-2 mt-4">
        <i class="fa fa-users me-2" aria-hidden="true" style="color:#b0894a;"></i> Transporte y Cliente
      </h6>
      <hr class="mt-1 mb-3">

      <div class="row">
        <div class="col-md-2 form-group">
          <label>Cía. Transporte</label>
          <div class="input-group">
            <input type="text" class="form-control" formControlName="proveedorId" (change)="getProveedor()">
            <div class="input-group-append">
              <app-busqueda-proveedor (onSelect)="proveedorSeleccionado($event)"></app-busqueda-proveedor>
            </div>
          </div>
        </div>

        <div class="col-md-4 form-group">
          <app-lfsa-input
            formControlName="proveedorNombre"
            [label]="'Detalle compañía'"
            [id]="'proveedorNombre'"
            [control]="formulario.get('proveedorNombre')"
            [type]="'text'"
            [isReadOnly]="true">
          </app-lfsa-input>
        </div>

        <div class="col-md-2 form-group">
          <label>Cliente</label>
          <div class="input-group">
            <input type="text" class="form-control" formControlName="cliente">
            <div class="input-group-append">
              <app-busqueda-cliente (onSelect)="clienteSeleccionado($event)"></app-busqueda-cliente>
            </div>
          </div>
        </div>

        <div class="col-md-4 form-group">
          <app-lfsa-input
            formControlName="clienteNombre"
            [label]="'Nombre Cliente'"
            [id]="'clienteNombre'"
            [control]="formulario.get('clienteNombre')"
            [type]="'text'"
            [isReadOnly]="true">
          </app-lfsa-input>
        </div>
      </div>

      <h6 class="fw-bold text-muted mb-2 mt-4">
        <i class="fa fa-user me-2" aria-hidden="true" style="color:#b0894a;"></i> Conductor
      </h6>
      <hr class="mt-1 mb-3">

      <div class="row">
        <div class="col-md-3 form-group">
          <app-lfsa-input
            formControlName="choferNombreFiltro"
            [label]="'Chofer (buscar por nombre)'"
            [id]="'choferNombreFiltro'"
            [control]="formulario.get('choferNombreFiltro')"
            [type]="'text'"
            (change)="buscarChoferes()">
          </app-lfsa-input>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-combo-box
            [label]="'Chofer'"
            formControlName="choferCedula"
            [control]="formulario.get('choferCedula')"
            [comboBox]="listChoferes"
            [opcion]="'nombres'"
            [idOpcion]="'cedula'"
            class="form-control-sm">
          </app-lfsa-combo-box>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-input
            formControlName="choferNombre"
            [label]="'Nombre chofer'"
            [id]="'choferNombre'"
            [control]="formulario.get('choferNombre')"
            [type]="'text'"
            [isReadOnly]="true">
          </app-lfsa-input>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-input
            formControlName="choferTelefono"
            [label]="'Teléfono chofer'"
            [id]="'choferTelefono'"
            [control]="formulario.get('choferTelefono')"
            [type]="'text'"
            [isReadOnly]="false">
          </app-lfsa-input>
        </div>
      </div>

      <h6 class="fw-bold text-muted mb-2 mt-4">
        <i class="fa fa-car me-2" aria-hidden="true" style="color:#b0894a;"></i> Vehículo y Documentación
      </h6>
      <hr class="mt-1 mb-3">

      <div class="row">
        <div class="col-md-3 form-group">
          <app-lfsa-loading-v2 *ngIf="placasLoading"></app-lfsa-loading-v2>
          <label>Placa</label>
          <ng-select
            [items]="placas"
            formControlName="placa"
            placeholder="Seleccione una Placa"
            [clearable]="false"
            bindLabel="placa"
            bindValue="placa">
          </ng-select>
        </div>

        <div class="col-md-3 form-group">
          <app-lfsa-input
            formControlName="furgon"
            [label]="'Furgón (opcional)'"
            [id]="'furgon'"
            [control]="formulario.get('furgon')"
            [type]="'text'">
          </app-lfsa-input>
        </div>

        <div class="col-md-6 form-group">
          <app-lfsa-input
            formControlName="sellos"
            [label]="'Editar Sellos'"
            [id]="'sellos'"
            [control]="formulario.get('sellos')"
            [type]="'text'">
          </app-lfsa-input>
        </div>
      </div>

      <app-lfsa-botones-formulario
        (devolverAccion)="acciones($event)"
        [formularioValido]="formulario.invalid"
        [loading]="loading"
        [textBoton]="'Guardar'"
        class="row p-3 mt-3">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
